<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button
              @click="previousDailyVehicleTrackView"
              size="sm"
              variant="light"
            >
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Daily Vehicle Track Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form> </b-nav-form>
          </b-navbar-nav> -->
        </b-navbar>
        <b-card>
          <b-row>
            <b-col md="3">
              <md-layout :md-flex="dateRange.startDate ? '25' : '15'">
                <date-range-picker
                  :opens="openRight"
                  :always-show-calendars="showCal"
                  v-model="dateRange"
                  :startDate="startDate"
                  :endDate="endDate"
                  :locale-data="locale"
                >
                </date-range-picker>
              </md-layout>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div class="w-100 text-center mt-3">
                <b-button
                  size="sm"
                  class="Mobile-Btn"
                  @click="filterSearch"
                  variant="outline-primary"
                  >Search</b-button
                >

                <b-button
                  size="sm"
                  class="ml-3 Mobile-Btn"
                  @click="clearFilter"
                  variant="outline-info"
                  >clear</b-button
                >
                <b-button
                  v-if="customVehicleTrack == true ? true : false"
                  size="sm"
                  class="ml-3 Mobile-Btn"
                  @click="getCustomIdelVehicleListDetails()"
                  variant="outline-info"
                  >Idle Vehicle List</b-button
                >

                <b-button
                  class="ml-3 Mobile-Btn"
                  v-if="customVehicleTrack == true ? true : false"
                  :disabled="ExcelBtnName != 'Export Idle Vehicle List' ? true : false"                  
                  @click="getCustomIdelVehicleList('CustomIdelVehicleList_SCREEN', '', 'Export Idle Vehicle List')"
                  size="sm"
                  variant="outline-info"
                  > {{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Export Idle Vehicle List'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>

                <!-- <b-button
                  v-if="customVehicleTrack == true ? true : false"
                  size="sm"
                  class="ml-3 Mobile-Btn"
                  @click="
                    getCustomIdelVehicleList('CustomIdelVehicleList_SCREEN', '')
                  "
                  variant="outline-info"
                  >Export Idle Vehicle List</b-button
                > -->
                <b-button
                  class="ml-3 Mobile-Btn"
                  :disabled="DailyExcelBtnName != 'Export Daily Idle Vehicle Excel' ? true : false" 
                  @click="getCustomIdelVehicleList('DailyVehicleTrack_SCREEN', '', 'Export Daily Idle Vehicle Excel')"
                  size="sm"
                  variant="outline-info"
                  > {{ DailyExcelBtnName }}
                  <b-spinner
                    v-if="DailyExcelBtnName != 'Export Daily Idle Vehicle Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>
                <!-- <b-button
                  size="sm"
                  class="ml-3 Mobile-Btn"
                  @click="
                    getCustomIdelVehicleList('DailyVehicleTrack_SCREEN', '')
                  "
                  variant="outline-info"
                  >Export Daily Idle Vehicle Excel</b-button
                > -->
              </div>
            </b-col>
          </b-row>
        </b-card>
        <div>
            <h5 class="text-muted pull-right mt-2 ml-3">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
        <div class="table-responsive tableMain mt-3">
          <!-- Main table element -->
          <b-table
            v-if="veiwVehicleMaster.length > 0"
            show-empty
            stacked="md"
            :items="veiwVehicleMaster"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="sr_no" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="tot_vehicle" slot-scope="row1">
              <!-- <b-button
                v-if="row1.index == 0"
                variant="outline-primary"
                @click="showDailyVehicleDeatils(row1.item, 'tot_vehicle')"
                size="sm"
                ><b>{{ row1.item.tot_vehicle }}</b></b-button
              >
              <b v-else>{{ row1.item.tot_vehicle }}</b> -->
              <b >{{ row1.item.tot_vehicle }}</b>
            </template>
            <template slot="tot_bookedGR" slot-scope="row2">
              <b-button
                v-if="row2.index == 0"
                variant="outline-danger"
                size="sm"
                @click="showDailyVehicleDeatils(row2.item, 'tot_bookedGR')"
                ><b>{{ row2.item.tot_bookedGR }}</b>
              </b-button>
              <b v-else>{{ row2.item.tot_bookedGR }}</b>
            </template>
            <template slot="tot_avilable" slot-scope="row3">
              <b-button
                v-if="row3.index == 0"
                variant="outline-success"
                size="sm"
                @click="showDailyVehicleDeatils(row3.item, 'tot_avilable')"
                ><b>{{ row3.item.tot_avilable }}</b>
              </b-button>
              <b v-else>{{ row3.item.tot_avilable }}</b>
            </template>
            <template slot="tot_inactive" slot-scope="row4">
              <!-- <b-button
                v-if="row4.index == 0"
                variant="outline-dark"
                size="sm"
                @click="showDailyVehicleDeatils(row4.item, 'tot_inactive')"
                ><b>{{ row4.item.tot_inactive }}</b>
              </b-button>
              <b v-else>{{ row4.item.tot_inactive }}</b> -->
              <b >{{ row4.item.tot_inactive }}</b>
            </template>
            <template slot="vehicle_log_date" slot-scope="row5">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="showDailyIdelVehicleList(row5.item)"
                ><b>{{ row5.item.vehicle_log_date }}</b></b-button
              >
            </template>
          </b-table>

          <b-table
            v-if="IdelVehicleList.length > 0"
            show-empty
            stacked="md"
            :items="IdelVehicleList"
            :fields="fields1"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="sr_no" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="vehicleNo" slot-scope="row1">{{
              row1.item.vehicleNo
            }}</template>
            <template slot="mainSalesSeries" slot-scope="row1">{{
              row1.item.mainSalesSeries
            }}</template>
            <template slot="clientName" slot-scope="row1">{{
              row1.item.clientName
            }}</template>
            <template slot="pickupLocation" slot-scope="row1">{{
              row1.item.pickupLocation
            }}</template>
            <template slot="stuffingLocation" slot-scope="row1">{{
              row1.item.stuffingLocation
            }}</template>
            <template slot="handoverLocation" slot-scope="row1">{{
              row1.item.handoverLocation
            }}</template>
            <template slot="MyvehicleReleaseDate" slot-scope="row1">{{
              row1.item.MyvehicleReleaseDate
            }}</template>
            <template slot="GRNSeries" slot-scope="row1">{{
              row1.item.GRNSeries
            }}</template>
            <template slot="GRDate" slot-scope="row1">{{
              row1.item.GRDate
            }}</template>
            <template slot="numberDays" slot-scope="row1">{{
              row1.item.numberDays
            }}</template>
          </b-table>
        </div>
        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              align="center"
            />
          </b-col>
        </b-row>

        <!-- Added By Priyanshu SIngh STart -->
        <b-modal
          no-close-on-esc
          no-close-on-backdrop
          size="xl"
          ref="DailyIdelVehicleList--modal"
          hide-footer
          title="Daily Idle Details"
          
        >
          <div class="d-block">
       <!--   <CustomLoader v-if="isLoading" :width="70"></CustomLoader>-->
            <b-row>
              <b-col>
                <h3>
                  <!-- Daily Idle Details -->
                  <span v-if="DailyIdelVehicleList.length > 0"
                    >{{ ChangeDateFormat(DailyIdelVehicleList[0]["created_at"]) }}
                  </span>
                </h3>
                <h3 v-if="DailyIdelVehicleList.length == 0">
                  Data Not Found !
                </h3>
              </b-col>
              <b-col style="text-align: end;">
                <!-- <b-button
                  v-if="DailyIdelVehicleList.length > 0"
                  size="sm"
                  @click="
                    getCustomIdelVehicleList(
                      'DailyIdelVehicleList_SCREEN',
                      DailyIdelVehicleList[0]['created_at'], 'Export as Excel'
                    )
                  "
                  variant="outline-info"
                  >Export as Excel</b-button
                > -->
                <b-button
                  v-if="DailyIdelVehicleList.length > 0"
                  size="sm"
                  :disabled="ExportExcelBtnName != 'Export As Excel' ? true : false"
                  @click="
                    getCustomIdelVehicleList(
                      'DailyIdelVehicleList_SCREEN',
                      '', 'Export As Excel'
                    )
                  "        
                  variant="outline-info"
                  > {{ ExportExcelBtnName }}
                  <b-spinner
                    v-if="ExportExcelBtnName != 'Export As Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>
                <!-- <b-button
                  variant="outline-danger"
                  @click="hideDailyVehicleDeatils"
                  >X</b-button
                > -->
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12">
              <table class="table table-sm table-bordered mt-2">
                <tbody style="background: white">
                  <tr v-if="DailyIdelVehicleList.length > 0">
                    <th scope="col" style="width: 5px">SN.</th>
                    <th scope="col" style="width: 600px">Vehical NO.</th>
                    <th scope="col" style="width: 600px">
                      Last Assignment No.
                    </th>
                    <th scope="col" style="width: 600px">Client</th>
                    <th scope="col" style="width: 180px">Location</th>
                    <!-- <th scope="col" style="width: 180px">Pickup Location</th>
                    <th scope="col" style="width: 180px">Stuffing Location</th>
                    <th scope="col" style="width: 180px">Handover Location</th> -->
                    <th scope="col" style="width: 180px">
                      Vehicle Release Date
                    </th>
                    <th scope="col" style="width: 180px">GR No.</th>
                    <th scope="col" style="width: 180px">GR Date.</th>
                    <th scope="col" style="width: 180px">Idle Days</th>

                    <!-- <th scope="col" style="width: 5px">Actions</th> -->
                  </tr>
                  <tr
                    v-for="(item, index) in DailyIdelVehicleList"
                    :key="index"
                  >
                    <th scope="row">{{ index + 1 }}.</th>
                    <td>{{ item.vehicleNo }}</td>
                    <td>{{ item.mainSalesSeries }}</td>
                    <td>{{ item.clientName }}</td>
                    <td>
                      Pickup : {{ item.pickupLocation }}<br />
                      Stuffing : {{ item.stuffingLocation }}<br />
                      Handover : {{ item.handoverLocation }}<br />
                    </td>
                    <!-- <td>{{item.pickupLocation}}</td>
                    <td>{{item.stuffingLocation}}</td>
                    <td>{{item.handoverLocation}}</td> -->
                    <td>{{ item.MyvehicleReleaseDate }}</td>
                    <td>{{ item.GRNSeries }}</td>
                    <td>{{ item.GRDate }}</td>
                    <td>{{ item.numberDays }}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <!-- <b-col cols="5"></b-col> -->
            <b-col class="text-center" >
              <b-button
                variant="outline-danger"
                @click="hideDailyIdelVehicleList"
                >Close</b-button
              >
            </b-col>
            <!-- <b-col cols="3"></b-col> -->
          </b-row>
        </b-modal>

        <b-modal
          no-close-on-esc
          no-close-on-backdrop
          size="xl"
          ref="DailyVehicleList--modal"
          hide-footer
          :title="viewType + ' Details'"
        >
        <b-row>
          <b-col cols="9">
            <h3>
              <!-- {{ this.viewType }} Details -->
              <span
                v-if="
                  DailyBookedVehicleList.length > 0 ||
                  DailyTotalVehicleList.length > 0 ||
                  DailyAvilableVehicleList.length > 0 ||
                  DailyInactiveVehicleList.length > 0
                "
                >{{ TodayDate }}
              </span>
            </h3>
            <!-- <h3 v-if="DailyBookedVehicleList.length <= 0 || DailyTotalVehicleList.length <= 0 || DailyAvilableVehicleList.length <= 0 || DailyInactiveVehicleList.length <= 0">
              Data Not Found !
            </h3> -->
          </b-col>
          <b-col cols="3" style="text-align: end;">
            <!-- <b-button
              v-if="
                DailyBookedVehicleList.length > 0 ||
                DailyTotalVehicleList.length > 0 ||
                DailyAvilableVehicleList.length > 0 ||
                DailyInactiveVehicleList.length > 0
              "
              size="sm"
              @click="
                getCustomIdelVehicleList(
                  'DailyIdelVehicleList_SCREEN',
                  DailyIdelVehicleList[0]['created_at'], 'Export as Excel'
                )
              "
              variant="outline-info"
              >Export as Excel</b-button
            > -->
            <b-button
              v-if="
                DailyBookedVehicleList.length > 0 ||
                DailyTotalVehicleList.length > 0 ||
                DailyAvilableVehicleList.length > 0 ||
                DailyInactiveVehicleList.length > 0
              "
              size="sm"
              :disabled="ExportExcelBtnName != 'Export As Excel' ? true : false"   
              @click="
                getCustomIdelVehicleListXLSX(
                  'DailyIdelVehicleList_SCREEN',
                 '', 'Export As Excel'
                )
              "
              variant="outline-info"
              > {{ ExportExcelBtnName }}
              <b-spinner
                v-if="ExportExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
            <!-- <b-button
              variant="outline-danger"
              @click="hideDailyVehicleDeatils"
              >X</b-button
            > -->
          </b-col>
        </b-row>
        <b-table
            show-empty
            stacked="md" 
            :items="DailyBookedVehicleList.length > 0 ? DailyBookedVehicleList : DailyTotalVehicleList"
            :fields="DailyBookedVehicleList.length > 0 ? ModalTotalBooking : ModalTotalVehicle"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="sr_no" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'GRvehicleNo':'regdNo'" slot-scope="row1">
              <span v-if="DailyBookedVehicleList.length > 0">
                {{ row1.item.GRvehicleNo }}
              </span>
              <span v-else >{{ row1.item.regdNo }}</span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'mainSalesSeries':'status'" slot-scope="row2">
              <span v-if="DailyBookedVehicleList.length > 0">
                {{ row2.item.mainSalesSeries }}
              </span>
              <span v-else >
                <h6
                  v-if="
                    row2.item.isTruckMasterActive == '1' &&
                    row2.item.vehicleActiveInactiveId == '1'
                  "
                >
                  <b-badge variant="success">Available</b-badge>
                </h6>
                <h6
                  v-if="
                    row2.item.isTruckMasterActive == '0' &&
                    row2.item.vehicleActiveInactiveId == '1'
                  "
                >
                  <b-badge variant="danger">Booked</b-badge>
                </h6>
                <h6 v-if="row2.item.vehicleActiveInactiveId == '2'">
                  <b-badge variant="dark">INACTIVE</b-badge>
                </h6>
              </span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'clientName':'vehicleType'" slot-scope="row3">
              <span v-if="DailyBookedVehicleList.length > 0">{{ row3.item.clientName }}</span>
              <span v-else>{{ row3.item.vehicleType }}</span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'pickupLocation':'engineNo'" slot-scope="row4">
              <span v-if="DailyBookedVehicleList.length > 0">
                Pickup : {{ row4.item.pickupLocation }}<br />
                Stuffing : {{ row4.item.stuffingLocation }}<br />
                Handover : {{ row4.item.handoverLocation }}<br />
              </span>
              <span v-else>{{ row4.item.engineNo }}</span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'MyvehicleReleaseDate':'chassisNo'" slot-scope="row5">
              <span v-if="DailyBookedVehicleList.length > 0">{{ row5.item.MyvehicleReleaseDate }}</span>
              <span v-else>{{ row5.item.chassisNo }}</span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'GRNSeries':'modNo'" slot-scope="row6">
              <span v-if="DailyBookedVehicleList.length > 0">{{ row6.item.GRNSeries }}</span>
              <span v-else>{{ row6.item.modNo }}</span>
            </template>
            <template :slot="DailyBookedVehicleList.length > 0 ?'GRDate':'driverName'" slot-scope="row7">
              <span v-if="DailyBookedVehicleList.length > 0">{{ row7.item.GRDate }}</span>
              <span v-else>{{ row7.item.driverName }}</span>
            </template>
          </b-table>

          
          <!-- <div class="d-block">
            <b-row>
              <b-col cols="9">
                <h3>
                  {{ this.viewType }} Details
                  <span
                    v-if="
                      DailyBookedVehicleList.length > 0 ||
                      DailyTotalVehicleList.length > 0 ||
                      DailyAvilableVehicleList.length > 0 ||
                      DailyInactiveVehicleList.length > 0
                    "
                    >{{ TodayDate }}
                  </span>
                </h3>
                <h3 v-if="DailyBookedVehicleList.length <= 0 || DailyTotalVehicleList.length <= 0 || DailyAvilableVehicleList.length <= 0 || DailyInactiveVehicleList.length <= 0">
                  Data Not Found !
                </h3> 
              </b-col>
              <b-col cols="3" style="text-align: end;">
                <b-button
                  v-if="
                    DailyBookedVehicleList.length > 0 ||
                    DailyTotalVehicleList.length > 0 ||
                    DailyAvilableVehicleList.length > 0 ||
                    DailyInactiveVehicleList.length > 0
                  "
                  size="sm"
                  @click="
                    getCustomIdelVehicleList(
                      'DailyIdelVehicleList_SCREEN',
                      DailyIdelVehicleList[0]['created_at']
                    )
                  "
                  variant="outline-info"
                  >Export as Excel</b-button
                >
                <b-button
                  variant="outline-danger"
                  @click="hideDailyVehicleDeatils"
                  >X</b-button
                >
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12">
              <table class="table table-sm table-bordered mt-2 ">
                <tbody
                  style="background: white"
                  v-if="DailyBookedVehicleList.length > 0"
                >
                  <tr v-if="DailyBookedVehicleList.length > 0">
                    <th scope="col" style="width: 5px">SN.</th>
                    <th scope="col" style="width: 600px">Vehical NO.</th>
                   <th scope="col" style="width: 600px">Vehical Status.</th>
                    <th scope="col" style="width: 600px">Assignment No.</th>
                    <th scope="col" style="width: 600px">Client</th>
                    <th scope="col" style="width: 180px">Location</th>
                    <th scope="col" style="width: 180px">Vehicle Release Date</th>
                    <th scope="col" style="width: 180px">GR No.</th>
                    <th scope="col" style="width: 180px">GR Date.</th>
                  </tr>
                  <tr
                    v-for="(item, index) in DailyBookedVehicleList"
                    :key="index"
                  >
                    <th scope="row">{{ index + 1 }}.</th>
                    <td>{{ item.GRvehicleNo }}</td>
                    <td>                      
                      <h6
                        v-if="
                          item.isTruckMasterActive == '1' &&
                          item.vehicleActiveInactiveId == '1'
                        "
                      >
                        <b-badge variant="success">Available</b-badge>
                      </h6>
                      <h6
                        v-if="
                          item.isTruckMasterActive == '0' &&
                          item.vehicleActiveInactiveId == '1'
                        "
                      >
                        <b-badge variant="danger">Booked</b-badge>
                      </h6>
                      <h6 v-if="item.vehicleActiveInactiveId == '2'">
                        <b-badge variant="dark">INACTIVE</b-badge>
                      </h6></td> 
                    <td>{{ item.mainSalesSeries }}</td>
                    <td>{{ item.clientName }}</td>
                    <td>
                      Pickup : {{ item.pickupLocation }}<br />
                      Stuffing : {{ item.stuffingLocation }}<br />
                      Handover : {{ item.handoverLocation }}<br />
                    </td>
                    <td>{{ item.MyvehicleReleaseDate }}</td>
                    <td>{{ item.GRNSeries }}</td>
                    <td>{{ item.GRDate }}</td>
                  </tr>
                </tbody>
                <tbody
                  style="background: white"
                  v-if="DailyTotalVehicleList.length > 0 || DailyAvilableVehicleList.length > 0 || DailyInactiveVehicleList.length > 0"
                >
                  <tr v-if="DailyTotalVehicleList.length > 0 || DailyAvilableVehicleList.length > 0 || DailyInactiveVehicleList.length > 0">
                    <th scope="col" >SN.</th>
                    <th scope="col">Vehical NO.</th>
                    <th scope="col">Status</th>
                    <th scope="col">Vehicle Type</th>
                    <th scope="col">Engine No.</th>
                    <th scope="col">Chassis No.</th>
                    <th scope="col">Modal No.</th>
                    <th scope="col">Driver Name</th>
                  </tr>
                  <tr
                    v-for="(item, index) in DailyTotalVehicleList"
                    :key="index"
                  >
                    <th scope="row">{{ index + 1 }}.</th>
                    <td>{{ item.regdNo }}</td>
                    <td>
                      <h6
                        v-if="
                          item.isTruckMasterActive == '1' &&
                          item.vehicleActiveInactiveId == '1'
                        "
                      >
                        <b-badge variant="success">Available</b-badge>
                      </h6>
                      <h6
                        v-if="
                          item.isTruckMasterActive == '0' &&
                          item.vehicleActiveInactiveId == '1'
                        "
                      >
                        <b-badge variant="danger">Booked</b-badge>
                      </h6>
                      <h6 v-if="item.vehicleActiveInactiveId == '2'">
                        <b-badge variant="dark">INACTIVE</b-badge>
                      </h6>
                    </td>
                    <td>{{ item.vehicleType }}</td>
                    <td> {{ item.engineNo }}</td>
                    <td>{{ item.chassisNo }}</td>
                    <td>{{ item.modNo }}</td>
                    <td>{{ item.driverName }}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row> -->

          <b-row class="mt-2">
            <!-- <b-col cols="5"></b-col> -->
            <b-col class="text-center">
              <b-button
                variant="outline-danger"
                @click="hideDailyVehicleDeatils"
                >Close</b-button
              >
            </b-col>
            <!-- <b-col cols="5"></b-col> -->
          </b-row>
        </b-modal>
        <!-- Added By Priyanshu SIngh End -->
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import { read, utils, writeFile } from "xlsx";

export default {
  beforeMount() {
    this.getCurrentLastDate();

    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      // alert(this.$sessionsStorage.get('nameUser'));
      // if ((this.$sessionsStorage.get('designation') == 'Admin' && this.$sessionsStorage.get('nameUser') == 'Bhavneesh') || (this.$sessionsStorage.get('designation') == 'Admin' && this.$sessionsStorage.get('nameUser') == 'Aaryav')) {
        this.$store.dispatch("setCurrentRoute", "/tpt/DailyVehicleTrack");
        this.ViewDailyVehicleTrack("0", "1", "1");
      // } else {
      //   this.$router.push({
      //     path: "/dashboard",
      //   });
      // }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Export Idle Vehicle List",
      DailyExcelBtnName: "Export Daily Idle Vehicle Excel",
      ExportExcelBtnName: "Export As Excel",
      viewType: "",
      customVehicleTrack: false,
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      clientIdFilter: "",
      assignmentFilter: "",
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      type: "",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      ModalTotalBooking: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "GRvehicleNo",
          mainkey: "GRvehicleNo",
          label: "Vehicle NO.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "pickupLocation",
          mainkey: "pickupLocation",
          label: "Location",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "MyvehicleReleaseDate",
          mainkey: "MyvehicleReleaseDate",
          label: "Vehicle Release Date",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "GRNSeries",
          mainkey: "GRNSeries",
          label: "GR No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "GRDate",
          mainkey: "GRDate",
          label: "GR Date.",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "LastGRNSeries",
          mainkey: "LastGRNSeries",
          label: "Last GR No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "LastGRDate",
          mainkey: "LastGRDate",
          label: "Last GR Date.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "LastmainSalesSeries",
          mainkey: "LastmainSalesSeries",
          label: "Last GR Job.",
          sortable: true,
          sortDirection: "ASC",
        },
         {
          key: "LastnumberDays",
          mainkey: "LastnumberDays",
          label: "Last GR Days.",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      ModalTotalVehicle: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "regdNo",
          mainkey: "regdNo",
          label: "Vehicle NO.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "status",
          mainkey: "status",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "vehicleType",
          mainkey: "vehicleType",
          label: "Vehicle Type",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "engineNo",
          mainkey: "engineNo",
          label: "Engine No",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "chassisNo",
          mainkey: "chassisNo",
          label: "Chassis No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "modNo",
          mainkey: "modNo",
          label: "Modal No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "driverName",
          mainkey: "driverName",
          label: "Driver Name",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "LastGRNSeries",
          mainkey: "LastGRNSeries",
          label: "Last GR No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "LastGRDate",
          mainkey: "LastGRDate",
          label: "Last GR Date.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "LastmainSalesSeries",
          mainkey: "LastmainSalesSeries",
          label: "Last GR Job.",
          sortable: true,
          sortDirection: "ASC",
        },
         {
          key: "LastnumberDays",
          mainkey: "LastnumberDays",
          label: "Last GR Days.",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      fields: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "tot_vehicle",
          mainkey: "tot_vehicle",
          label: "Total Vehicle",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "tot_bookedGR",
          mainkey: "tot_bookedGR",
          label: "Total Booked",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "tot_avilable",
          mainkey: "tot_avilable",
          label: "Total Avilable",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "tot_inactive",
          mainkey: "tot_inactive",
          label: "Total Inactive",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "vehicle_log_date",
          mainkey: "vehicle_log_date",
          label: "Date",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
      ],
      fields1: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "vehicleNo",
          mainkey: "vehicleNo",
          label: "Vehical NO.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Last Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "pickupLocation",
          mainkey: "pickupLocation",
          label: "Pickup Location",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "stuffingLocation",
          mainkey: "stuffingLocation",
          label: "Stuffing Location",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "handoverLocation",
          mainkey: "handoverLocation",
          label: "Handover Location",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "MyvehicleReleaseDate",
          mainkey: "MyvehicleReleaseDate",
          label: "Vehicle Release Date",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "GRNSeries",
          mainkey: "GRNSeries",
          label: "GR No.",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "GRDate",
          mainkey: "GRDate",
          label: "GR Date",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
        {
          key: "numberDays",
          mainkey: "numberDays",
          label: "Idle Days",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },

      isLoading: false,
      //isLoadingm : false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      excelUpload: "",
      veiwVehicleMaster: [],
      DailyIdelVehicleList: [],
      IdelVehicleList: [],
      DailyBookedVehicleList: [],
      DailyTotalVehicleList: [],
      DailyAvilableVehicleList: [],
      DailyInactiveVehicleList: [],
      TodayDate: "",
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$router.push({
        path: "/vehicle/truckMaster",
      });
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleMas11").DataTable({
          lengthChange: false,
          width: 100,
          dom: '<"wrapper"iftp>',
        });
      });
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewSubscription(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.ViewDailyVehicleTrack("0", "1", "1");
      this.customVehicleTrack = true;
    },
    clearFilter() {
      this.customVehicleTrack = false;
      this.clientIdFilter = "";
      this.DateFilter = "";
      this.assignmentFilter = "";
      this.assignmentNo = "assignmentNo";
      this.ViewDailyVehicleTrack("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.ViewDailyVehicleTrack(CURRENT, "2", event);
    },
    ViewDailyVehicleTrack(CURRENT, SEARCH, pageNumber) {
      this.doLoading();
      let type_Size = {
        excelId: "",
        DateFilter: this.DateFilter,
        assignmentNo: this.assignmentNo,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        viewDet: "VehicleTrack",
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDailyVehicleTrackDetails.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("MyData=>", data);
            if (data.mainVehicleTrackData.length > 0) {
              this.veiwVehicleMaster = data.mainVehicleTrackData;
              this.totalRows = data.mainVehicleTrackData.length;
              this.IdelVehicleList = [];
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    previousDailyVehicleTrackView() {
      window.history.go(-1);
    },

    getCustomIdelVehicleListXLSX() {
      // Determine which data and fields to use based on the table logic
      let exportData = [];
      let exportFields = [];
      let fileName = '';
      if (this.DailyBookedVehicleList.length > 0) {
        exportData = this.DailyBookedVehicleList;
        exportFields = this.ModalTotalBooking;
        fileName = 'Daily_Booked_Vehicle_List.xlsx';
      } else {
        exportData = this.DailyTotalVehicleList;
        exportFields = this.ModalTotalVehicle;
        fileName = 'Daily_Total_Vehicle_List.xlsx';
      }

      // Prepare headings from exportFields
      const headings = [exportFields.map(f => f.label)];

      // Prepare row data
      const rows = exportData.map((item, idx) => {
        return exportFields.map(f => {
          // Custom logic for computed columns (status, etc.)
          if (f.key === 'sr_no') {
            return idx + 1;
          }
          if (f.key === 'status') {
            if (item.isTruckMasterActive == '1' && item.vehicleActiveInactiveId == '1') {
              return 'Available';
            } else if (item.isTruckMasterActive == '0' && item.vehicleActiveInactiveId == '1') {
              return 'Booked';
            } else if (item.vehicleActiveInactiveId == '2') {
              return 'INACTIVE';
            } else {
              return '';
            }
          }
          // For other fields, just return the value
          return item[f.key] !== undefined ? item[f.key] : '';
        });
      });

      // Use xlsx to export
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_aoa(ws, rows, { origin: 'A2' });
      utils.book_append_sheet(wb, ws, 'Report');
      writeFile(wb, fileName);
    },
    getCustomIdelVehicleList(id, date, btnName) {
      let excelIdGivin = "";
      let SingleDate = "";
      if (id == "CustomIdelVehicleList_SCREEN") {
        excelIdGivin = "CustomIdelVehicleList_SCREEN";
        SingleDate = "";
      } else if (id == "DailyIdelVehicleList_SCREEN") {
        excelIdGivin = "DailyIdelVehicleList_SCREEN";
        SingleDate = date;
      } else if (id == "DailyVehicleTrack_SCREEN") {
        excelIdGivin = "DailyVehicleTrack_SCREEN";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        DateFilter: this.DateFilter,
        assignmentNo: "assignmentNo",
        searchVal: this.filter,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        SingleDate: SingleDate,
      };
      if (id == "CustomIdelVehicleList_SCREEN") {
        this.ExcelBtnName = "Downloading Please Wait .....";
      } else if(id=="DailyVehicleTrack_SCREEN"){
        this.DailyExcelBtnName = "Downloading Please Wait .....";
      } else if(id == "DailyIdelVehicleList_SCREEN"){
        this.ExportExcelBtnName = "Downloading Please Wait .....";;
      } 
        
      CommonService.getCustomIdelVehicleListExcel(view_Assignment)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              if (id == "CustomIdelVehicleList_SCREEN") {
                this.ExcelBtnName = btnName;
              } else if(id=="DailyVehicleTrack_SCREEN"){
                this.DailyExcelBtnName = btnName;
              } else if(id == "DailyIdelVehicleList_SCREEN"){
                this.ExportExcelBtnName = btnName;
              } 
              
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
                // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
                
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getCustomIdelVehicleListExcel Error: ", error);
        });
      },

      // getCustomIdelVehicleList(id, date) {
      //   this.isLoading = true;
      //   let excelIdGivin = "";
      //   let SingleDate = "";
      //   if (id == "CustomIdelVehicleList_SCREEN") {
      //     excelIdGivin = "CustomIdelVehicleList_SCREEN";
      //     SingleDate = "";
      //   } else if (id == "DailyIdelVehicleList_SCREEN") {
      //     excelIdGivin = "DailyIdelVehicleList_SCREEN";
      //     SingleDate = date;
      //   } else if (id == "DailyVehicleTrack_SCREEN") {
      //     excelIdGivin = "DailyVehicleTrack_SCREEN";
      //   }
      //   let view_Assignment = {
      //     excelId: excelIdGivin,
      //     DateFilter: this.DateFilter,
      //     assignmentNo: "assignmentNo",
      //     searchVal: this.filter,
      //     fromDate: this.dateSearch.fromDate,
      //     toDate: this.dateSearch.toDate,
      //     dateRange: this.dateRange,
      //     SingleDate: SingleDate,
      //   };
      //   console.log(view_Assignment);
      //   // return false;
      //   let options = {
      //     method: "POST",
      //     url: `${URL_BASE}/Api_Common/getCustomIdelVehicleListExcel.php`,
      //     data: JSON.stringify(view_Assignment),
      //     crossDomain: true,

      //     headers: {
      //       Accept: "application/json",
      //       "Content-Type": "application/json",
      //       Authorization: this.$sessionsStorage.get("loginId"),
      //     },
      //   };

      //   axios(options)
      //     .then((result) => {
      //       const { statusText, status, data } = result;
      //       if (status == 200 && data) {
      //         if (data.excelName != undefined) {
      //           window.location.href =
      //             `https://uploadsp.pridel.com/Pridel_Reports/` +
      //             data.excelName;
      //         }
      //         this.isLoading = false;
      //       }
      //     })
      //     .catch((error) => {});
      // },


    getCustomIdelVehicleListDetails(
      CURRENT = "0",
      SEARCH = "1",
      pageNumber = "1"
    ) {
      let IdelVehicleListdata = {
        viewDet: "ViewIdelVehicleList",
        searchVal: this.filter,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        fields: this.fields1,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDailyIdelVehicleList.php`,
        data: JSON.stringify(IdelVehicleListdata),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("Daily Idle Vehicle List=>", data);
            if (data.DailyIdelVehicleList.length > 0) {
              this.IdelVehicleList = data.DailyIdelVehicleList;
              this.totalRows = data.DailyIdelVehicleList.length;
              this.veiwVehicleMaster = [];
            }
          }
        })
        .catch((error) => {});
    },
    getDailyIdelVehicleList(items) {
      // alert(items.vehicle_log_date);return false;
      let DailyIdelVehicleListdata = {
        viewDet: "ViewDailyIdelVehicleList",
        vehicle_log_date: items.vehicle_log_date,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDailyIdelVehicleList.php`,
        data: JSON.stringify(DailyIdelVehicleListdata),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("Daily Idle Vehicle List=>", data);
            this.DailyIdelVehicleList = data.DailyIdelVehicleList;
          }
        })
        .catch((error) => {});
    },
    showDailyIdelVehicleList(item) {
      this.DailyIdelVehicleList = [];
      this.getDailyIdelVehicleList(item);
      this.$refs["DailyIdelVehicleList--modal"].show();
    },
    hideDailyIdelVehicleList() {
      this.$refs["DailyIdelVehicleList--modal"].hide();
      this.isLoading = false;
      // this.viewTypeSize("0", "1", "1");
    },
    showDailyVehicleDeatils(item, type) {
      console.log("item=>", item);
      console.log("type=>", type);
      this.isLoading = true;
      this.viewType = "";
      if (type == "tot_vehicle") {
        this.viewType = "Total Vehicle";
      } else if (type == "tot_bookedGR") {
        this.viewType = "Total Booked Vehicle";
      } else if (type == "tot_avilable") {
        this.viewType = "Total Avilable Vehicle";
      } else if (type == "tot_inactive") {
        this.viewType = "Total Inactive Vehicle";
      }
      this.DailyBookedVehicleList = [];
      this.DailyTotalVehicleList = [];
      this.DailyAvilableVehicleList = [];
      this.DailyInactiveVehicleList = [];
      this.DailyVehicleList = [];
      this.getDailyVehicleList(item, type);
      this.$refs["DailyVehicleList--modal"].show();
    },
    hideDailyVehicleDeatils() {
      this.$refs["DailyVehicleList--modal"].hide();
      this.isLoading = false;
    },
    getDailyVehicleList(items, type) {
      // alert(items.vehicle_log_date);return false;
      let DailyVehicleListdata = {
        viewDet: "ViewDailyVehicleList",
        type: type,
        items: items,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDailyVehicleList.php`,
        data: JSON.stringify(DailyVehicleListdata),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
          this.isLoading = false;
            console.log("Daily Vehicle List=>", data);
            this.DailyBookedVehicleList = data.DailyBookedVehicleList;
            if(data.DailyTotalVehicleList.length>0){
              this.DailyTotalVehicleList = data.DailyTotalVehicleList;
              this.DailyAvilableVehicleList = [];
              this.DailyInactiveVehicleList = [];
            }else if(data.DailyAvilableVehicleList.length>0){
              this.DailyTotalVehicleList = data.DailyAvilableVehicleList;
              this.DailyAvilableVehicleList = [];
              this.DailyInactiveVehicleList = [];
            }else if(data.DailyInactiveVehicleList.length>0){
              this.DailyTotalVehicleList = data.DailyInactiveVehicleList;
              this.DailyAvilableVehicleList = [];
              this.DailyInactiveVehicleList = [];
            }
            // this.DailyAvilableVehicleList = data.DailyAvilableVehicleList;
            // this.DailyInactiveVehicleList = data.DailyInactiveVehicleList;
            this.TodayDate = data.TodayDate;
          }
        this.isLoading = false;
        })
        .catch((error) => {});
    },
    ChangeDateFormat(date){
    return moment(date).format("Do MMMM YYYY");
}
  },
};
</script>
<style scoped>
body {
  table-layout: fixed !important;
}
@media only screen and ( min-width: 320px ) and ( max-width: 767px ) {
  .Mobile-Btn {
    width:100% !important;
    margin-bottom:5px;
    margin-left:0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// DailyVehicleTrack.vue?727b677a